module.exports = __webpack_public_path__ + "assets/6.png";


//////////////////
// WEBPACK FOOTER
// ./images/6.png
// module id = 701
// module chunks = 0